<template>
  <div class="content">
    <form action="" @submit.prevent="approve_cin">
      <div class="md-layout md-size-100" v-if="platform_data_fetched">
        <md-toolbar :md-elevation="1">
          <span class="md-title md-size-33">Podaci o platformi</span>
        </md-toolbar>

        <div class="md-layout-item md-size-100">
          <md-field>
            <label>Naziv Platforme</label>
            <md-input
              v-model="working_entry.platforma.platforma_naziv"
              :disabled="platform_locked"
              required
            ></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-100">
          <md-field>
            <label>Opis Platforme</label>
            <md-input
              v-model="working_entry.platforma.platforma_opis"
              :disabled="platform_locked"
              required
            ></md-input>
          </md-field>
        </div>

        <div class="md-layout-item">
          <md-field>
            <label for="platforma_lokacija">Platforma Lokacija</label>
            <md-select
              v-model="working_entry.platforma.platforma_lokacija"
              name="platforma_lokacija"
              id="platforma_lokacija"
              placeholder="platforma_lokacija"
              :disabled="platform_locked"
              
            >
              <md-option value=""></md-option>
              <md-option value="Bosna i Hercegovina"
                >Bosna i Hercegovina</md-option
              >
              <md-option value="Bosna i Hercegovina - RS"
                >Bosna i Hercegovina - RS</md-option
              >
              <md-option value="Bosna i Hercegovina - FBiH"
                >Bosna i Hercegovina - FBiH</md-option
              >
              <md-option value="Bosna i Hercegovina - BD"
                >Bosna i Hercegovina - BD</md-option
              >
              <md-option value="Republika Srbija">Republika Srbija</md-option>
              <md-option value="Crna Gora ili Hrvatska"
                >Crna Gora ili Hrvatska</md-option
              >
              <md-option value="Ostale države iz regije"
                >Ostale države iz regije</md-option
              >
              <md-option value="Ostale države">Ostale države</md-option>
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item">
          <md-field>
            <label for="platforma_financiranje_sektor"
              >Izvor Financiranja Platforme</label
            >
            <md-select
              v-model="working_entry.platforma.platforma_financiranje_sektor"
              name="platforma_financiranje_sektor"
              id="platforma_financiranje_sektor"
              :disabled="platform_locked"
              
            >
              <md-option value=""></md-option>
              <md-option value="Poznato: Javna sredstva"
                >Poznato: Javna sredstva</md-option
              >
              <md-option value="Poznato: Donacije">Poznato: Donacije</md-option>
              <md-option value="Poznato: Komercijalno"
                >Poznato: Komercijalno</md-option
              >
              <md-option value="NA">Nepoznato</md-option>
              <md-option value="Nepoznato">Nepoznato</md-option>
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item">
          <md-field>
            <label for="platforma_tip_medija">Tip Medija</label>
            <md-select
              v-model="working_entry.platforma.platforma_tip_medija"
              name="platforma_tip_medija"
              id="platforma_tip_medija"
              :disabled="platform_locked"
              
            >
              <md-option value=""></md-option>
              <md-option value="Javna novinska agencija"
                >Javna novinska agencija</md-option
              >
              <md-option value="Javna RTV">Javna RTV</md-option>
              <md-option value="Komercijalna novinska agencija"
                >Komercijalna novinska agencija</md-option
              >
              <md-option value="Komercijalni medij"
                >Komercijalni medij</md-option
              >
              <md-option value="Anonimna web stranica"
                >Anonimna web stranica</md-option
              >
              <md-option value="Društvene mreže">Društvene mreže</md-option>
              <md-option value="Naučni rad">Naučni rad</md-option>
              <md-option value="Knjiga">Knjiga</md-option>
              <md-option value="Ostalo">Ostalo</md-option>
            </md-select>
          </md-field>
        </div>
      </div>

    <div class="md-layout">
    <md-button
    type="submit"
        class="md-dense md-raised md-primary submit"
        >Spasi izmjenu</md-button
    >
    </div>
    </form>
    <md-dialog :md-active.sync="show_modal_success">
      <md-dialog-title>Uspješan unos</md-dialog-title>

        <div class="md-layout">
          <p class="md-layout-item">Unos je uspješno spašen, hvala vam na vašem doprinosu!</p>
        </div>

      <md-dialog-actions>
        <md-button class="md-primary" @click="reload_page">Zatvoriti</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="show_modal_error">
      <md-dialog-title>Greška pri unosu!</md-dialog-title>

        <div class="md-layout">
          <p class="md-layout-item">{{aktivni_error_text}}</p>
        </div>

      <md-dialog-actions>
        <md-button class="md-primary" @click="show_modal_error = false">Zatvoriti</md-button>
      </md-dialog-actions>
    </md-dialog>

  </div>
  
</template>

<script>
import axios from "axios";
export default {
  name: "Ispravka",
  methods: {
    reload_page(event){
      this.$router.push('/platforme')
    },
    async approve_cin(event) {
      const token = await this.$auth.getTokenSilently()
      if(this.working_entry.platforma.platforma_naziv == "" || this.working_entry.platforma.platforma_naziv == "")
      {
        return null
      }

      var data_prepared = {
        cin: {},
        negator: {},
        platforma: {},
      };
        data_prepared.platforma = this.working_entry.platforma;

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      };

      axios
        .put(
          "https://hxy5npx7g6.execute-api.eu-west-1.amazonaws.com/platforme/"+this.$route.params.id,
          data_prepared.platforma,
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (response.status == 200) {
            this.show_modal_success = true
          } 
          
        })
        .catch((error) => {
          
           
        this.aktivni_error_text = this.opci_error_text;   
        this.show_modal_error = true;          
        });
    }
        
  },
  data: () => ({
    initial: "Initial Value",
    type: null,
    naming_conflict: "Negator ili platforma kojeu pokušavate unijeti već postoji u bazi podataka, molim vas odaberite već postojeće iz dropdowna.",
    opci_error_text:"Došlo je do neočekivane greške tokom unosa podataka, molim vas napravite screenshot i pošaljite nam ga da možemo provjeriti u čemu je problem. Izvinjavamo se zbog smetnje",
    aktivni_error_text: "",
    show_modal_error: false,
    show_modal_success: false,
    data_fetched: false,
    withLabel: null,
    inline: null,
    number: null,
    textarea: null,
    autogrow: null,
    disabled: null,
    working_platforma: {},
    active_entry: {},
    working_entry: {
      cin: {
        cin_nacin_negiranja: "",
        cin_datum: "",
        cin_uuid_platforma: "",
        cin_uuid_negator: "",
        cin_drzava: "",
        cin_naslov: "",
        cin_link: "",
        cin_citat_opis: "",
      },
      negator: {
        negator_financiranje: "",
        negator_drzava: "",
        negator_ime_naziv: "",
        negator_oblast: "",
        negator_rod: "",
        negator_sektor: "",
        negator_karakteristike: "",
        negator_uloga_u_ratu: "",
        negator_opis: "",
      },
      platforma: {
        platforma_lokacija: "",
        platforma_opis: "",
        platforma_tip_medija: "",
        platforma_financiranje_sektor: "",
        platforma_naziv: "",
      },
    },
    platform_locked: false,    
    platform_data_fetched: false
  }),
  mounted: async function () {
    const token = await this.$auth.getTokenSilently()
    axios
      .get("https://hxy5npx7g6.execute-api.eu-west-1.amazonaws.com/platforme/"+this.$route.params.id,
      {headers:{Authorization: `Bearer ${token}`}})
      .then(((response) => {
          this.working_entry.platforma = response.data
        }))
        .then((response) => {this.platform_data_fetched = true;})
    
  }
};
</script>